module.exports = __webpack_public_path__ + "img/ztjback.be8e7c7b.png";